<template>
    <div>
        <!-- image-input image-input-changed -->
        <div class="image-input" :class="{ 'image-input-changed': changed }" id="kt_image_2">
            <div class="image-input-wrapper"
                :style="{
                    backgroundImage: tempImage ? `url(${tempImage})` : `url(${$storage('/usuarios/fotos/' + tempCurrentImage)})`
                }"
            ></div>

            <label class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
                <i class="fa fa-fw fa-pen text-muted"></i>
                <input type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" @change="onChangeFile"/>
            </label>

            <span @click="onClickCancel" class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="cancel" data-toggle="tooltip" title="Cancel avatar">
                <i class="fa fa-fw fa-times text-muted"></i>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        currentImage: String,
    },
    data() {
        return {
            changed: false,
            tempImage: null,
            tempCurrentImage: this.currentImage
        }
    },
    watch: {
        currentImage(newVal, oldVal) {
            let vm = this;
            vm.tempCurrentImage = newVal;
            vm.tempImage = null;
            vm.changed = false;
            vm.$emit('input', null);
        }
    },
    methods: {
        onChangeFile(e) {
            let vm = this;
            let files = e.target.files;

            if(!files.length) {
                vm.tempImage = null;
                vm.changed = false;
                vm.$emit('input', null);
                return;
            };

            let fr = new FileReader();

            fr.onload = function(efr) {
                vm.tempImage = efr.target.result;
            }

            fr.readAsDataURL(files[0]);
            vm.changed = true;

            vm.$emit('input', files[0]);

        },
        onClickCancel() {
            let vm = this;
            vm.tempImage = null;
            vm.changed = false;
            vm.$emit('input', null);
        }
    }
}
</script>
